'use strict';

var App = require('app');
var EventLogItem = require('components/devices/views/common/event_log_item');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var Consts = require('consts');
var Notification = require('utils/notification');

var EventLogList = Marionette.CollectionView.extend({
    childView: EventLogItem,
});

var EventLog = Marionette.LayoutView.extend({
    template: require('components/devices/templates/common/event_log'),
    templateEventLog: require('components/devices/templates/common/event_log_item'),

    regions: {
        content: '#js-event-log',
        filter: '#js-filter',
    },

    ui: {
        datepicker: '#js-datepicker',
        eventFilter: '#js-event-filter',
        timeInterval: '#js-predefined-timerange',
        itemsPerPage: '#js-items-per-page',
    },

    events: {
        'hide.bs.select @ui.eventFilter': 'setFilter',
        'changed.bs.select @ui.timeInterval': 'setTimeInterval',
        'changed @ui.itemsPerPage': 'setItemsPerPage',
    },

    itemsPerPage: 20,
    currentPage: 1,

    initialize: function (data) {
        this.controller = data.controller;
        this.model = data.model;
        this.eventLogReq = data.eventLog;
        this.startDate = moment().subtract(1, 'days');
    },

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);

        data.eventLog = this.getEventLog();
        data.eventCount = this.totalCount;

        data.periods = [
            { name: i18n.TR('15 Minuten'), value: '15-minutes' },
            { name: i18n.TR('1 Stunde'), value: '1-hour' },
            { name: i18n.TR('1 Tag'), value: '1-days' },
            { name: i18n.TR('7 Tage'), value: '7-days' },
            { name: i18n.TR('30 Tage'), value: '30-days' },
            { name: i18n.TR('60 Tage'), value: '60-days' },
            { name: i18n.TR('365 Tage'), value: '365-days' },
            { name: i18n.TR('alles'), value: 'all' },
            { name: i18n.TR('frei'), value: 'free' },
        ];
        data.filter = this.types;
        data.timeInterval = this.timeInterval || '1-days';

        return data;
    },

    setFilter: function () {
        this.types = $(this.ui.eventFilter).val();
        // new filter -> start at first page
        this.currentPage = 1;
        this.refreshContent();
    },

    setTimeInterval: function () {
        this.timeInterval = this.ui.timeInterval.val();
        if (this.timeInterval === 'free') {
            // do nothing
            return;
        }

        if (this.timeInterval === 'all') {
            this.startDate = undefined;
            this.endDate = undefined;
        } else {
            var timeSpan = $(this.ui.timeInterval).val().split('-');
            this.startDate = moment().subtract(timeSpan[0], timeSpan[1]);
            this.endDate = moment();
        }

        this.refreshContent();
    },

    setPermission: function () {},

    templateHelpers: {
        title: i18n.TR('Keine Auswahl'),
        options: Consts.Events,
    },

    getEventLog: function () {
        var self = this;
        var result = '';

        _.each(this.eventLog || [], function (eli) {
            var data = eli.toJSON();
            self.setEventData(data);
            result += self.templateEventLog(data);
        });

        return result;
    },

    setEventData: function (item) {
        switch (item.item_type) {
            case 'device_status':
            case 'device_ok':
                item.errors = Misc.getErrorsFromStatus(item.ref_id, item.category, item.custom_data);
                break;
        }
    },

    onShow: function () {
        Misc.initSelectPicker();
        Misc.initDatePicker();
        var self = this;
        $.when(this.eventLogReq).done(function (eventLog) {
            if (eventLog === undefined) {
                Notification.show('error', i18n.TR('Fehler'), i18n.TR('Ereignisse konnten nicht abgeholt werden'));
                return;
            }
            self.eventLog = eventLog.models;
            self.totalCount = eventLog.count;
            self.setPageCount();
            self.render();
        });
    },
    onRender: function () {
        var self = this;
        $(this.ui.datepicker).daterangepicker(
            Misc.setDatePickerOptions({ startDate: self.startDate, endDate: self.endDate }),
            function () {
                self.startDate = this.startDate;
                self.endDate = this.endDate;
                self.timeInterval = 'free';
                self.refreshContent();
            }
        );
        Misc.initSelectPicker();
        Misc.initDatePicker();
        this.attachPagination();
    },

    goToPage: function (page) {
        this.currentPage = page;
        this.refreshContent();
    },

    setPageCount: function () {
        this.pageCount = this.itemsPerPage == -1 ? 1 : Math.ceil(this.totalCount / this.itemsPerPage);
        this.currentPage = this.currentPage > this.pageCount ? this.pageCount : this.currentPage;
    },

    setItemsPerPage: function (value) {
        this.currentPage = 1;
        this.itemsPerPage = value;
        this.setPageCount();
        this.refreshContent();
    },

    onAttach: function () {
        this.attachPagination();
    },

    attachPagination: function () {
        this.setPageCount();
        var p = Misc.generatePagination({
            currentPage: this.currentPage || 1,
            pageCount: this.pageCount,
            totalCount: this.totalCount,
            itemsPerPage: this.itemsPerPage,
            context: this,
            onGotoPage: this.goToPage,
            onSetItemsPerPage: this.setItemsPerPage,
        });

        $('#js-pagination').append(p.html);
        p.initEvents();
    },

    refreshContent: function () {
        this.filter = {
            eventType: [this.types],
            itemCount: this.itemsPerPage,
            currentPage: this.currentPage,
            timeFrom: this.startDate,
        };

        if (this.timeInterval === 'free') {
            this.filter.timeTill = this.endDate;
        }

        var self = this;
        var req = App.request('device:eventlog', this.filter, this.model.id);
        $.when(req).done(function (data) {
            if (self.contentView === undefined) {
                self.contentView = new EventLogList({ controller: self.controller, collection: data });
                self.showChildView('content', self.contentView);
            } else {
                self.contentView.collection = data;
            }
            if (data) {
                self.eventLog = data.models;
                self.totalCount = data.count;
            }
            self.render();
        });

        this.render();
    },
});

module.exports = EventLog;
